__turbopack_context__.v({
  "blok-big-title": "ShowroomSelect-module__6_oY-a__blok-big-title",
  "blok-subtitle": "ShowroomSelect-module__6_oY-a__blok-subtitle",
  "blok-title": "ShowroomSelect-module__6_oY-a__blok-title",
  "select": "ShowroomSelect-module__6_oY-a__select",
});
